import React from 'react';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import DealDay from "../../pages/dealOfDay/DealDay"
export default function DialogEditDeal ({ dealId, open, handleClose, fromEditAction }) {
    return (
        <div>
            <Dialog open={open} aria-labelledby="form-dialog-title" maxWidth="lg">
                <DialogTitle id="form-dialog-title">{dealId ? "Update" : "Create"} Deal of day settings</DialogTitle>
                <DialogContent>
                    <DealDay dealId={dealId} handleClose={handleClose} fromEditAction={fromEditAction} />
                </DialogContent>
            </Dialog>
        </div >
    );
}